'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.forms.form.teams', {
            url: '/teams',
            templateUrl: 'dashboard-form-teams/dashboard-form-teams.html',
            controller: 'dashboardFormTeamsCtrl as ctrl',
            resolve: {
                teams: ['Department', '$stateParams', function(Department, $stateParams) {
                    return Department.teams({
                        id: $stateParams.departmentId,
                        filter: {
                            include: [{
                                relation: 'subscribedTo',
                                scope: {
                                    fields: 'id'
                                }
                            }, {
                                relation: 'members',
                                scope: {
                                    fields: 'id'
                                }
                            }]
                        }
                    }).$promise.then(function(teams) {
                        return teams;
                    });

                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser']
            }
        });
};
